import React, {Component} from 'react';
import VideosSmall from "./VideoSmall";
import VideosMedium from "./VideoMedium";
import VideoTable from "./VideoTable";
import IFrameContainer from "../../utils/IFrameContainer";
import ModuleNav from "../../mainFrame/ModuleNav";
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import Job from "../../utils/Job";
import PropTypes from "prop-types";

class VideoListContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        videoSource: PropTypes.string.isRequired,
        activeVideoCategory: PropTypes.string.isRequired,
        videoList: PropTypes.object.isRequired,
        prevLink: PropTypes.string.isRequired,
        handleStateChange: PropTypes.func.isRequired,
        updateVideoList: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: 'smallView',
            videoList: [],
        };

        this.translate = this.props.baseData.translate;

        this.handleViewChange = this.handleViewChange.bind(this);
        this.setModalContent = this.setModalContent.bind(this);

        this.updateVideoListJob = new Job(this.updateVideoList.bind(this), 10000);

    }

    componentWillMount() {

        this.updateVideoListJob.start(true);

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  View aus den userprops laden
        const activeView = (settings.viewVideos) ? settings.viewVideos : 'smallView';

        if (activeView) state.activeView = activeView;

        this.setState(state);

    }

    componentWillUnmount() {

        this.props.handleStateChange();

        this.updateVideoListJob.stop();

    }

    updateVideoList() {

        this.props.updateVideoList();

    }

    handleViewChange(view) {

        this.props.baseData.saveSettings('viewVideos', view);

        this.setState({activeView: view});

    }

    navigate(event) {

        if (this.props.onClick) {
            event.preventDefault();

            this.props.onClick();
        }

        return null;

    }

    getVideoList() {

        if (this.props.activeVideoCategory && this.props.videoList) {
            const activeCategory = this.props.activeVideoCategory;
            const videos = this.props.videoList;

            if (typeof videos !== 'undefined') {
                if (typeof videos['videoList'] !== 'undefined') {
                    if (typeof videos['videoList']['video-' + activeCategory] !== 'undefined') {
                        if (videos['videoList']['video-' + activeCategory].length > 0) {
                            return videos['videoList']['video-' + activeCategory];
                        }
                    }
                }
            }
        }

        return [];

    }

    getVideoById(videoId) {

        const videoList = this.getVideoList();

        let videoData = null;

        if (videoList.length > 0) {
            videoList.map((item) => {
                if (videoId === item.videoId) {
                    videoData = item;
                }
            });
        }

        return videoData;

    }

    setModalContent(v) {

        if (!v) return null;

        const videoData = this.getVideoById(v);
        const videoUrl = StaticVideoFunctions.getVideoUrl(videoData.videoId, this.props.videoSource);

        this.props.baseData.modalData({
            content: <div style={{width: '800px'}}>
                <IFrameContainer
                    height="replaceModalContentHeight"
                    width="replaceModalContentWidth"
                    src={videoUrl}
                />
            </div>
        });

    }

    renderVideos() {

        if (this.props.activeVideoCategory && this.props.videoList) {
            const videos = this.getVideoList();
            const activeView = this.state.activeView;

            if (activeView === 'smallView') {
                return <VideosSmall
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'mediumView') {
                return <VideosMedium
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    translate={this.translate}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'tableView') {
                return <VideoTable
                    baseData={this.props.baseData}
                    videoList={videos}
                    source={this.props.videoSource}
                    onClick={this.setModalContent}
                />;
            } else {
                return this.translate('noViewFound');
            }
        }

        return this.translate('noVideosFound');

    }

    renderStyles() {

        const videos = this.getVideoList();
        const videoCounter = videos.length;
        const maxTimeForFadeIn = (videoCounter >= 10) ? 2 : 1;
        const secondsPerChild = maxTimeForFadeIn / videoCounter;

        let styles = '';

        for (let i = 1; i <= videoCounter; i++) {
            styles += '.fadeInArea .fadeInItem:nth-child(' + i + ') { animation-delay: ' + i * secondsPerChild + 's; } ';
        }

        return styles;

    }

    render() {

        //const videoContainerClasses = ['archivContainer', 'col-xs-12', 'col-sm-6', 'col-md-3', 'col-lg-2'].join(' ').trim();
        const archivAreaClasses = ['archivArea', this.state.activeView].join(' ').trim();
        const videos = this.renderVideos();

        if (this.props.videoSource) {
            return (
                <div className="VideoListContainer">
                    <nav>
                        <h1>{this.props.activeVideoCategoryName}</h1>

                        <ModuleNav translate={this.translate}
                                   activeView={this.state.activeView}
                                   onClick={this.handleViewChange}
                        />
                    </nav>

                    <div className={archivAreaClasses}>
                        <div className="fadeInArea clearfix">
                            {videos}
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        <a className="prewLink" onClick={(e) => this.navigate(e)}>{this.translate('backToOverview')}</a>
                    </div>
                </div>
            );
        } else {
            return <div>&nbsp;</div>;
        }

    }

}

export default VideoListContainer;